import React, { useEffect, useState } from "react";
import CheckboxInput from "../checkboxInput/CheckboxInput";
import ImageCheckbox from "../imageCheckbox/ImageCheckbox";
import NumberInput from "../numberInput/NumberInput";
import QuestionCards from "../questionCards/QuestionCards";
import RadioInput from "../radioInput/RadioInput";
import RangeSlider from "../rangeSlider/RangeSlider";
import "./QuestionareSecondStep.css";

const QuestionareSecondStep = ({
  allQuestions,
  allAnswers,
  setAllAnswers,
  handleAnswer,
  handleChecked,
  handleOther,
  isInError,
}) => {
  const [isCheckUsed, setCheckUsed] = useState(false);
  const handleInputChecked = (question, answer, questions) => {
    handleAnswer(question, answer, questions);
    if (answer !== "It started for no apparent reason") {
      setCheckUsed(false);
    } else {
      setCheckUsed(true);
    }
  };

  const [sliderValuesRange] = useState({
    startValue: "0",
    secondValue: "01",
    thirdValue: "02",
    fourthValue: "03",
    fifthValue: "04",
    sixthValue: "05",
    seventhValue: "06",
    eighthValue: "07",
    ninthValue: "08",
    tenthValue: "09",
    endValue: "10",
  });
  const [sliderValuesInPercent] = useState({
    startValue: "0%",
    secondValue: "",
    thirdValue: "20%",
    fourthValue: "",
    fifthValue: "40%",
    sixthValue: "",
    seventhValue: "60%",
    eighthValue: "",
    ninthValue: "80%",
    tenthValue: "",
    endValue: "100%",
  });

  const slider = (question, e, questions) => {
    const baseTen = Math.ceil(e.target.value / 10) * 10;
    handleAnswer(question, baseTen, questions);
  };

  const handleImages = (question, value, questions) => {
    handleAnswer(question, value, questions);
  };

  const handleNumber = (num) => {
    if (isNaN(num)) {
      return false;
    }
  };

  const handleNumberClick = (param, noVal) => {
    param === "up" ? (noVal += 1) : (noVal -= 1);
    if (noVal < 0) {
      noVal = 0;
    }
    return noVal;
  };

  const handleFullNumber = (question, e, questions) => {
    let numVal = e.target.value;
    handleNumber(numVal);
    handleAnswer(question, parseInt(e.target.value), questions);
  };
  const handleFullNumberClick = (question, param, questions) => {
    let noVal = allAnswers && allAnswers[question] ? allAnswers[question] : 0;
    noVal = handleNumberClick(param, noVal);
    handleAnswer(question, noVal, questions);
  };

  useEffect(() => {
    for (var question in allAnswers) {
      var ansObj = { ...allAnswers };
      if (ansObj[question] == 0) {
        delete ansObj[question];
      }
      //setAllAnswers(ansObj);
    }
  }, [handleFullNumber, handleFullNumberClick]);

  return (
    <div className="formContainer">
      {allQuestions &&
        allQuestions.sections &&
        allQuestions.sections.map(
          (section, key) =>
            (key === 1 || key === 2) && (
              <>
                {section.title &&
                  (key === 1 ? (
                    <>
                      <div key={key} className="formTitle">
                        {section.title}
                      </div>
                      <div className="formText">{allQuestions.top_instructions}</div>
                    </>
                  ) : (
                    <div key={key} className="formTitle additionalSpace">
                      {section.title}
                    </div>
                  ))}
                {section.questions.map((question, q) => (
                  <div
                    key={q}
                    className={
                      isInError && !allAnswers[question.question_id] && !question.is_optional
                        ? "formContainerError"
                        : "formContainer"
                    }
                  >
                    <div
                      className={
                        isInError && !allAnswers[question.question_id] && !question.is_optional
                          ? "formSubtitleError"
                          : "formSubtitle"
                      }
                    >
                      {(question.question ? question.question_number + ". " : "") + question.question}
                    </div>
                    {question.answers.map((answer, a) => (
                      <div key={a} className={question.question_type === "questionCards" ? "question_card_wrap" : ""}>
                        {question.question_type === "radio" ? (
                          <div>
                            <RadioInput
                              isChecked={(function () {
                                if (
                                  allAnswers &&
                                  allAnswers[question.question_id] &&
                                  allAnswers[question.question_id] === answer.name
                                ) {
                                  return true;
                                } else if (answer.name === "Other") {
                                  for (var ansr of question.answers) {
                                    if (allAnswers[question.question_id] === ansr.name) {
                                      return false;
                                    }
                                  }
                                  if (allAnswers[question.question_id]) {
                                    return true;
                                  } else {
                                    return false;
                                  }
                                } else {
                                  return false;
                                }
                              })()}
                              textValue={answer.name}
                              isOther={answer.name === "Other"}
                              otherAnswers={question.answers}
                              otherParams={[question.question_id, section.questions]}
                              handleAnswer={handleAnswer}
                              checkRadio={() => {
                                return;
                              }}
                              isInError={isInError && !allAnswers[question.question_id] && !question.is_optional}
                            />
                          </div>
                        ) : question.question_type === "checkbox" ? (
                          <CheckboxInput
                            isChecked={answer.isChecked === true}
                            textValue={answer.name}
                            section={key}
                            question={q}
                            answer={a}
                            handleFunction={handleChecked}
                            handleOther={handleOther}
                            isInError={isInError && !allAnswers[question.question_id] && !question.is_optional}
                          />
                        ) : question.question_type === "radioWithCheckbox" ? (
                          a === question.answers.length - 1 ? (
                            <div onClick={() => handleAnswer(question.question_id, answer.name, section.questions)}>
                              <RadioInput
                                isChecked={
                                  allAnswers &&
                                  allAnswers[question.question_id] &&
                                  allAnswers[question.question_id] === answer.name
                                    ? true
                                    : false
                                }
                                textValue={answer.name}
                                otherAnswers={question.answers}
                                otherParams={[question.question_id, section.questions]}
                                handleAnswer={handleAnswer}
                                checkRadio={() => {
                                  return;
                                }}
                                isInError={isInError && !allAnswers[question.question_id] && !question.is_optional}
                              />
                            </div>
                          ) : (
                            <>
                              <CheckboxInput
                                isChecked={answer.isChecked}
                                textValue={answer.name}
                                section={key}
                                question={q}
                                answer={a}
                                handleFunction={handleChecked}
                                handleOther={handleOther}
                                isInError={isInError && !allAnswers[question.question_id] && !question.is_optional}
                              />
                            </>
                          )
                        ) : question.question_type === "inputWithCheckbox" ? (
                          <div
                            className={
                              isInError && !allAnswers[question.question_id] && !question.is_optional
                                ? " prog_err_input"
                                : ""
                            }
                          >
                            <input
                              type="text"
                              value={
                                allAnswers &&
                                allAnswers[question.question_id] &&
                                allAnswers[question.question_id] !== "It started for no apparent reason"
                                  ? allAnswers[question.question_id]
                                  : ""
                              }
                              className="input_field_questionare"
                              onChange={(e) =>
                                handleInputChecked(question.question_id, e.target.value, section.questions)
                              }
                              disabled={allAnswers[question.question_id] === "It started for no apparent reason"}
                            />
                            <div className="formCheckSmallContain">
                              <div
                                className={
                                  "questionare_checkbox formCheckSmall" +
                                  (isCheckUsed ? " questionare_checkbox_selected" : "")
                                }
                                onClick={() =>
                                  !isCheckUsed
                                    ? handleInputChecked(question.question_id, answer.name, section.questions)
                                    : handleInputChecked(question.question_id, "", section.questions)
                                }
                              ></div>
                              <div className="checkSmallText">{answer.name}</div>
                            </div>
                          </div>
                        ) : question.question_type === "slider" ? (
                          <>
                            <div className="formTextSub">{answer.name}</div>
                            <RangeSlider
                              percentage={
                                allAnswers && allAnswers[question.question_id] ? allAnswers[question.question_id] : 0
                              }
                              sliderPercentage={slider}
                              question={question.question_id}
                              questions={section.questions}
                              sliderValuesRange={
                                question.question === "Tell us about your level of pain on a scale of 1 to 10?"
                                  ? sliderValuesRange
                                  : sliderValuesInPercent
                              }
                              isInError={isInError && !allAnswers[question.question_id] && !question.is_optional}
                            />
                          </>
                        ) : question.question_type === "numberInput" ? (
                          <>
                            <div className="formTextSub">{answer.name}</div>
                            <NumberInput
                              numberValue={
                                allAnswers && allAnswers[question.question_id] ? allAnswers[question.question_id] : 0
                              }
                              numberInputValue={handleFullNumber}
                              question={question.question_id}
                              questions={section.questions}
                              numberInputChange={handleFullNumberClick}
                              isInError={isInError && !allAnswers[question.question_id] && !question.is_optional}
                            />
                          </>
                        ) : question.question_type === "questionCards" ? (
                          <div onClick={() => handleAnswer(question.question_id, answer.name, section.questions)}>
                            <QuestionCards
                              isChecked={
                                allAnswers &&
                                allAnswers[question.question_id] &&
                                allAnswers[question.question_id] === answer.name
                                  ? true
                                  : false
                              }
                              cardValue={answer.name}
                              isInError={isInError && !allAnswers[question.question_id] && !question.is_optional}
                            />
                          </div>
                        ) : question.question_type === "imageCheckbox" ? (
                          <ImageCheckbox
                            imageOptionSelected={allAnswers ? allAnswers[question.question_id] : ""}
                            question={question.question_id}
                            questions={section.questions}
                            handleImageOptions={handleImages}
                            isInError={isInError && !allAnswers[question.question_id] && !question.is_optional}
                          />
                        ) : question.question_type === "Input" ? (
                            <input
                              type="text"
                              maxLength={205}
                                value={
                                  allAnswers &&
                                  allAnswers[question.question_id] &&
                                  allAnswers[question.question_id] !== "It started for no apparent reason"
                                    ? allAnswers[question.question_id]
                                    : ""
                                }
                                className="input_field_questionare"
                                onChange={(e) =>
                                  handleInputChecked(question.question_id, e.target.value, section.questions)
                                }
                            />
                          )
                            : (
                            ""
                          )}
                      </div>
                    ))}
                  </div>
                ))}
                {key === 1 && <div className="horizontalRuler"></div>}
              </>
            )
        )}
    </div>
  );
};

export default QuestionareSecondStep;
